export * from './after';

//# sourceMappingURL=index.js.map